import React from "react";
import checkmarkIcon from './images/checkmark-step.svg';
export default function StepsProgressBar({ currentStep, steps }) {

  const currentIndex = steps.findIndex(element => element === currentStep);

  return (
    <div className="steps-progress-bar">
      {steps.map((step, i) => (
              <div className={`step-container`} key={i}>
                  <div className={`step ${i == currentIndex ? 'step-active' : (!currentStep || i < currentIndex ) ? 'step-end' : ''}`}>
                    <span className="step-circle">{ !currentStep || i < currentIndex ? <span className="checkmark" style={{backgroundImage:checkmarkIcon.bg()}} /> : <span className="number">{i+1}</span>}</span>
                    <span className="step-title">{step}</span>
                    <span className="spacer"/>
                  </div>
              </div>
        ))}
    </div>
  );
}
